import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, get, set } from "firebase/database";
import { auth, db } from "./utils/db";

import { IonApp } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route, Redirect } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import "@ionic/react/css/core.css";
import "./App.css";
import { setupIonicReact } from "@ionic/react";

import Login from "./pages/Login";
import Home from "./pages/Home";
import CreateSheet from "./pages/CreateSheet";
import PrivateRoute from "./elements/PrivateRoute";
import ViewSheet from "./pages/ViewSheet";
import Register from "./pages/Register";
import PasswordReset from "./pages/PasswordReset";

setupIonicReact();

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        // Busca o usuário no database
        const userRef = ref(db, `users/${authUser.uid}`);
        const userSnap = await get(userRef);

        if (userSnap.exists()) {
          setUser({ uid: authUser.uid, ...userSnap.val() });
        } else {
          // Caso não exista no DB ainda, cria com role default
          const displayName =
            authUser.displayName || authUser.email.split("@")[0];
          const userData = {
            uid: authUser.uid,
            email: authUser.email,
            name: displayName,
            role: "jogador",
          };
          await set(userRef, userData);
          setUser(userData);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading)
    return (
      <IonApp>
        <p>Carregando...</p>
      </IonApp>
    );

  return (
    <IonApp>
      <IonReactRouter>
        <IonRouterOutlet>
          <Route
            path="/login"
            render={(props) => <Login {...props} onLogin={setUser} />}
          />
          <Route
            path="/register"
            render={(props) => <Register {...props} onRegister={setUser} />}
          />
          <Route
            path="/password-reset"
            render={(props) => <PasswordReset {...props} />}
          />
          <PrivateRoute path="/home" component={Home} user={user} />
          <PrivateRoute
            path="/create-sheet"
            component={CreateSheet}
            user={user}
          />
          <PrivateRoute path="/view-sheet" component={ViewSheet} user={user} />
          <Route exact path="/">
            <Redirect to={user ? "/home" : "/login"} />
          </Route>
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
}
